module.exports = __webpack_public_path__ + "static/media/new-bg.50dd2d92.png";